import type { Style } from 'exceljs';
import { Details, HistoricalDetails } from '@common/types/taxExpenseReports';

import { SheetExportTypes } from './xlsxExport.constants';

import gridBuilder, { GridBuilderSheet } from './builders/gridBuilder';
import reportBuilder, { ReportBuilderSheet } from './builders/reportBuilder';
import etrBuilder, { EtrBuilderSheet } from './builders/etrBuilder';
import customBuilder, { CustomBuilderSheet } from './builders/customBuilder';
import blankBuilder from './builders/blankBuilder';
import scenarioReportBuilder, { ScenarioReportBuilderSheet } from './builders/scenarioReportBuilder';

import templateInstructionsBuilder, { TemplateInstructionsBuilderSheet } from './builders/templateInstructionsBuilder';
import { ColumnDefinition } from '@common/xlsxExport/types';

export type SheetOptions = {
  shouldDisplayZero?: boolean,
  hideDecimals?: boolean,
  negativeMinus?: boolean,
  omitExportIfNull?: boolean,
  addTimestamp?: boolean,
  splitDescriptionColumn?: boolean,
  isFunctionalCurrency?: boolean,
  numberOfAdditionalRowsToStick?: number,
  numberOfColumnsToStick?: number,
  headerRowHeight?: number,
  totalColumnName?: string,
  displayGroupingColumnsByPercentages?: boolean,
  aggregationFields?: string[],
  detailRows?: HistoricalDetails[string] | Details[string] | null,
  groupByTag?: boolean,
  rowStyles?: Partial<Style> & { outlineLevel?: number, },
  cellStyles?: { address: { row: number, column: number }, style: Partial<Style> }[]
  createAutoFilter?: boolean,
  dataColumnStartIndex?: number,
  dataColumnEndIndex?: number,
}

export type SheetDefinition<TData = unknown> = {
  columnDefinitions?: ColumnDefinition[],
  name: string,
  type: SheetExportTypes,
  data: TData,
  options: SheetOptions
}

export type SheetMetadata = {
  fileName?: string,
  disableHeaderRendering?: boolean,
  description?: string,
  periodName?: string,
}

export type FormatSheetParams = GridBuilderSheet
    | ReportBuilderSheet
    | EtrBuilderSheet
    | ScenarioReportBuilderSheet
    | CustomBuilderSheet
    | TemplateInstructionsBuilderSheet;
export const formatSheet = (metadata: SheetMetadata = {}) => (sheet: FormatSheetParams) => {
  switch (sheet.type) {
    case SheetExportTypes.GRID:
      return gridBuilder(sheet, {
        ...metadata,
      });
    case SheetExportTypes.REPORT:
      return reportBuilder(sheet, {
        ...metadata,
      });
    case SheetExportTypes.ETR_REPORT:
      return etrBuilder(sheet, {
        ...metadata,
      });
    case SheetExportTypes.CUSTOM:
      return customBuilder(sheet, {
        ...metadata,
      });
    case SheetExportTypes.SCENARIO_REPORT:
      return scenarioReportBuilder(sheet);
    case SheetExportTypes.TEMPLATE_INSTRUCTIONS:
      return templateInstructionsBuilder(sheet);
    default:
      return blankBuilder();
  }
};
